import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";
import { config } from "../_helpers/global";
import { TriageSidebar } from "../Layouts/TriageSidebar";

export class SingleTreatment extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      prescriptionserial: localStorage.getItem("prescriptionserialnumber"),
      remarks: "",
      status: "",
      loading: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {
    console.log(this.state.prescriptionserial);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
   this.ssetState({
    loading: true
   })
    axios
      .post(this.api_url+"prescription/labour", this.state, {
        headers: headers,
      })
      .then((response) => {
        this.ssetState({
          loading: false
         })

        if (response.data["status"]) {
          $(".alert-success").show();
          setTimeout(function () {
            // window.location.href = '/prior/ob/or/gyn/infections'
          }, 1000);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  render() {
    const font16 = { fontSize: "18px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { prescriptionserial, remarks, status, loading } = this.state;
    return (
      <div>
        <Headers />
        <TriageSidebar></TriageSidebar>

        <main className="content-container ">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-12 font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Prescription Administration
                  </p>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Prescription Serial Number
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={prescriptionserial}
                      name="prescriptionserial"
                      type="text"
                      readOnly
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Prescription Status
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={status}
                      name="status"
                      required
                    >
                      <optgroup label="Has Prescription been administered">
                        <option selected disabled></option>
                        <option
                          value="yes"
                          className="antenatalCareAttendedYes"
                        >
                          Yes
                        </option>
                        <option value="no" className="noAnswer1">
                          No
                        </option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Addition Remarks
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={remarks}
                      name="remarks"
                      required
                    ></textarea>
                  </div>
                </div>
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>

              <div className="row">
                <br />
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                  {loading ? 'Loading' : 'Submit'}  
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default SingleTreatment;
